module.exports = __webpack_public_path__ + "static/media/rentsmarter.5638f06a.png";